import React from 'react';
import { twMerge } from 'tailwind-merge';

import { PlanCta } from '../../../app/Navigation/types';
import { LoggerFn } from '../../../app/Shared/types';
import { Button, ButtonColor, ButtonSize } from '../../../storywind';

type Props = {
  logger: LoggerFn;
  planCta: PlanCta;
  mobile?: boolean;
};

const PlanCtaButton = ({ planCta, logger, mobile = false }: Props) => {
  return (
    <Button
      id={planCta.id}
      color={ButtonColor.Primary}
      size={ButtonSize.Small}
      className={twMerge(
        'mainNav-cta lg:inline-block px-5 py-2 m-0 whitespace-nowrap font-inter font-semibold',
        mobile ? '' : 'hidden'
      )}
      onClick={() => logger('conversion.ump.' + planCta.id)}
      href={planCta.url}
    >
      {mobile ? planCta.mobileLinkText : planCta.linkText}
    </Button>
  );
};

export default PlanCtaButton;
